import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HelpIcon from '@mui/icons-material/Help';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Inc,Dataset,Owner,Item,ItemSearchCondition,TakebackState,Customer} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import ItemListSearch from './ItemListSearch';
import ItemCheckTable from './ItemCheckTable';
import TakebackInput from './TakebackInput';
import TakebackConfirm from './TakebackConfirm';
import TakebackSuccess from './TakebackSuccess';
import Toast from './Toast';
import Title from './Title';
import AppBank from './AppBank';

interface TakebackListProps {
	owner:Owner,
	bank:AppBank,
}
// let p:number = 1;
// let customer:Customer;

const TakebackList = (props:TakebackListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defItems:Item[] = [];
	const defPages:Dataset[] = [];
	const defCheckedIds:number[] = [];
	const defCheckedItems:Item[] = [];
	const defInputs:TakebackState = {
		how_id:"",
		message:"",
		values:[],
		samples:[],
		hasSample:false,
		hasError:false,
	}

	const [states,setStates] = useState({
		items:defItems,
		checkedIds:defCheckedIds,
		checkedItems:defCheckedItems,
		inputs:defInputs,
		isLoading:true,
		isFinished:false,
		sheetId:0,
		modalPage:"",
		toast:"",
		customer:{} as Customer,
		currentPage:1,
		pager:null,
        cond:Inc.defaultItemSearchCondition(),
	});
	const [pages,setPages] = useState(defPages);
	const load = async()=>{
		await Ajax.send("takeback/customer",{},(res:any)=>{
			if( res.ok ){
				setStates(prev=>({...prev,"customer":res.customer}));
			}
		});
		await Ajax.send("item/pages",{},(res:any)=>{
			if( res.ok ){
				setPages(res.pages);
			}
		});
	}
    const search = (cond:ItemSearchCondition,page:number)=>{
		setStates(prev=>({...prev,"isLoading":true}));
		// if( first ){
		// 	p = 1;
		// }
		window.scrollTo(0,0);
        Ajax.search("item/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates(prev=>({...prev,items:res.items,cond:cond,currentPage:page,pager:res.pager,isLoading:false}));
            } else {
                setStates(prev=>({...prev,"isLoading":false}));
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		//p = to;
		search(states.cond,to);
	}
	const check = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( !states.checkedIds.includes(item.item_id) ){
			setStates(prev=>({...prev,"checkedItems":prev.checkedItems.concat(item),"checkedIds":prev.checkedIds.concat(item.item_id)}));
		}
	}
	const uncheck = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( states.checkedIds.includes(item.item_id) ){
			let ids = states.checkedIds;
			const index1 = ids.findIndex((v) => v===item.item_id);
			ids.splice(index1,1);

			let items = states.checkedItems;
			const index2 = items.findIndex((v) => v.item_id===item.item_id);
			items.splice(index2,1);

			setStates(prev=>({...prev,"checkedItems":items,"checkedIds":ids}));
		}
	}
	const isChecked = (id:number)=>{
		return states.checkedIds.includes(id);
	}
	const input = ()=>{
		setStates(prev=>({...prev,"modalPage":"input"}));
	}
	const confirm = (data:TakebackState)=>{
		setStates(prev=>({...prev,"modalPage":"confirm","inputs":data}));
	}
	const send = ()=>{
		setStates(prev=>({...prev,"modalPage":"","isLoading":true}));
		let list:Dataset[] = [];
		for( let i=0 ; i<states.checkedItems.length ; i++ ){
			list.push( {
				id: String(states.checkedItems[i].item_id),
				label: String(states.inputs.values[i]),
			})
		}
		//console.log("list",list,states.inputs);
		Ajax.send("takeback/entry",{items:list,memo:states.inputs.message,how_id:states.inputs.how_id,samples:states.inputs.samples},(res:any)=>{
			//console.log( res );
			if( res.ok ){
				setStates(prev=>({...prev,"modalPage":"success","isLoading":false,"checkedIds":defCheckedIds,"checkedItems":defCheckedItems,"inputs":defInputs}));
			} else {
				setStates(prev=>({...prev,"isLoading":false,"toast":"error"}));
			}
		})
	}
	const closeToast = ()=>{
		setStates(prev=>({...prev,"toast":""}));
	}
	const closeModal = ()=>{
		if( states.modalPage==="success" ){
			setStates(prev=>({...prev,"modalPage":"","checkedItems":defItems,"checkedIds":defCheckedIds,isFinished:true}));
		} else {
			setStates(prev=>({...prev,"modalPage":""}));
		}
	}
	const checkable = (item:Item)=>{
		if( item.num_stock===0 && item.sample_flag!=='1' ) {
			return false;
		}
		return true;
	}
	useEffect( ()=>{
		load();
	},[]);

	if( states.isFinished ){
		return <Redirect to='/return'/>
	}
	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div id="item_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="商品引取の申請" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
							納品した商品の引き取り（委託終了）を申請します。<br/>
							引き取りたい商品を選択してから、「商品の確認」を押して下さい。 <br/>
							<Hidden mdUp implementation="js">
								<Grid container spacing={1} style={{marginTop:"1em"}}>
									<Grid item xs={6}><Button variant="text" color="primary" component={Link} to='/first/p5' startIcon={<HelpIcon/>}>ご利用ガイド</Button></Grid>
									<Grid item xs={6}>
									<div style={{textAlign:'right'}}>
										<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={input} disabled={states.checkedIds.length===0}><ShoppingCartIcon/>商品の確認</Button></Badge>
									</div>
									</Grid>
								</Grid>
							</Hidden>
                        </div>

						<ItemCheckTable items={states.items} owner={props.owner} check={check} uncheck={uncheck} isChecked={isChecked} checkable={checkable}/>

						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Hidden mdDown implementation="js">
						<Paper className={classes.paper} style={{marginBottom:"1em"}}>
							<Title text="商品を選んだら" size={2}/>
							<FormControl fullWidth={true}>
								<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={input} disabled={states.checkedIds.length===0}>
									<ShoppingCartIcon/>商品の確認
								</Button></Badge>
							</FormControl>
							<div style={{textAlign:'right'}}>
								<Button variant="text" color="primary" component={Link} to='/first/p5' startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button>
								<Button variant="text" color="primary" component={Link} to='/return' startIcon={<ArrowForwardIcon/>}>一覧にもどる</Button>
							</div>
						</Paper>
					</Hidden>
	
                    <Paper className={classes.paper}>
                        <ItemListSearch pages={pages} update={search} bank={props.bank} bankKey={"savedTakebackListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Toast mes={states.toast} close={closeToast}/>
			<TakebackInput isOpen={states.modalPage==="input"} next={confirm} close={closeModal} items={states.checkedItems} inputs={states.inputs} owner={props.owner}/>
			<TakebackConfirm isOpen={states.modalPage==="confirm"} next={send} close={closeModal} back={input} items={states.checkedItems} inputs={states.inputs} owner={props.owner} customer={states.customer}/>
			<TakebackSuccess isOpen={states.modalPage==="success"} owner={props.owner} close={closeModal}/>
		</div>
	);
}

export default TakebackList;
